import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { map, switchMap } from 'rxjs/operators';
import { ELearningManagementService } from '../e-learning-management.service';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-assignment',
  templateUrl: './assignment.component.html',
  styleUrls: ['./assignment.component.scss']
})
export class AssignmentComponent implements OnInit {

  isAssign: boolean;
  courseId: string;
  allAssignmentDetail;
  course;

  constructor(
    public matDialog: MatDialog,
    private eLearningService: ELearningManagementService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.isAssign = JSON.parse(new URL(location.href).searchParams.get('isAssign'));
    this.gobalFunctionService.setTitle('การจัดการ Assignment');

    this.courseId = new URL(location.href).searchParams.get('course_id');

    this.eLearningService.getAllReceiveAssignmentById(this.courseId).pipe(
      map(res => {
        this.allAssignmentDetail = res.result;
      }),
      switchMap(res => {
        return this.eLearningService.getDetailCourseById(this.courseId).pipe(
          map(res2 => {
            this.course = res2.result[0];

            // console.log(this.course);
          })
        )
      })
    ).subscribe();
  }

  assign(aid, aname, cname, cNum) {

    aname = this.allAssignmentDetail[0].ASSIGNMENT_NAME;
    cname = this.allAssignmentDetail[0].COURSE_NAME;
    cNum = this.allAssignmentDetail[0].COURSE_NUMBER;
    // console.log(aname);
    // console.log(cname);
    // console.log(cNum);

    window.open('/e-learning-management/assignment-management?assignmentId=' + aid, '_blank');
  }

}


